import React, { useState } from 'react';
import { usePopper } from 'react-popper';

interface PopperProps extends React.HTMLProps<HTMLDivElement> {
  anchorEl?: HTMLElement;
  children: React.ReactNode;
  fullWidth?: boolean;
}

const fullWidthStyle = { width: '100%', left: '0', right: '0' };

const Popper: React.FC<PopperProps> = (props) => {
  const { anchorEl, children, fullWidth, style = {} } = props;

  const [popperEl, setPopperEl] = useState<HTMLElement | null>(null);
  const { styles, attributes } = usePopper(anchorEl, popperEl);

  return (
    <div
      ref={setPopperEl}
      style={{ ...styles.popper, ...style, ...(fullWidth ? fullWidthStyle : {}) }}
      {...attributes.popper}
    >
      {children}
    </div>
  );
};

export default Popper;
